import { User } from '../../shared/models';
import { ChatMessage, Thread } from '../models';
import { Component, Input, ElementRef,  DoCheck } from '@angular/core';

declare var $: JQueryStatic;

interface JQueryStatic {
    (selector: string): JQueryStatic;
    animate(options: any, duration: number);
}


@Component({
    selector: 'messages-container',
    template: require('./messages-container.component.pug'),
})
export class MessagesContainerComponent implements  DoCheck {
@Input() messages: ChatMessage[];
@Input() user: User;
@Input() thread: Thread;

    private lastScrollHeight: number = 0;
    private el: any;

    constructor(private element: ElementRef) {
      this.el = this.element.nativeElement;
    }

   ngDoCheck() {
      if (this.lastScrollHeight === 0) {
          this.el.scrollTop = 0;
      }

      let isScrolledToBottom = this.el.scrollHeight - this.el.clientHeight
                               - this.el.scrollTop <= 80;

      if (this.lastScrollHeight !== this.el.scrollHeight && isScrolledToBottom) {
           $('messages-container').animate({ scrollTop:
                                             this.el.scrollHeight -
                                             this.el.clientHeight 
                                           }, 500);
        this.lastScrollHeight = this.el.scrollHeight;
      }

   }
}






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/messages-container/messages-container.component.ts